import { executeAction, getDeviceAction } from '@ps/workbench/undo-redo'
import i18n from '@ps/lang'

const device = {
  namespaced: true,

  state: {
    // 目前新 ps 中只用到 pdef 和 ldef, pdef 代表竖屏，ldef 代表横屏
    adapterResolution: 'pdef',
    anotherResolution: 'ldef',

    orientationList: [
      {
        value: 0,
        label: i18n.t('workbench.board.device.orientationList.horizontal')
      },
      {
        value: 1,
        label: i18n.t('workbench.board.device.orientationList.portrait')
      }
    ],

    // orientation 的值， 1 代表竖屏， 0 代表横屏
    orientation: 1,

    resolutionList: [
      {
        value: 1,
        label: '375x667',
        width: 375,
        height: 667,
        scaleX: 0.6,
        scaleY: 0.6
      },
      {
        value: 2,
        label: '375x734',
        width: 375,
        height: 734,
        scaleX: 0.75,
        scaleY: 0.75
      },
      {
        value: 3,
        label: '768x1024',
        width: 768,
        height: 1024,
        scaleX: 0.6,
        scaleY: 0.6
      }
    ],
    resolution: 1,

    width: 375,
    height: 667,

    scaleList: [
      {
        value: -1,
        label: i18n.t('workbench.board.device.adaptToTheScreen')
      },
      {
        value: 2,
        label: '200%'
      },
      {
        value: 1,
        label: '100%'
      },
      {
        value: 0.5,
        label: '50%'
      }
    ],
    scale: 1,

    // 为啥要缓存起来，因为旋转屏幕时，通过 gameIframe.UIRoot.getWorldScale() 获取的值会变化，因此需要在 gameReady 时缓存起当前游戏世界缩放值
    worldScale: {
      x: 0.5,
      y: 0.5
    },

    sceneWidth: '100%',
    sceneHeight: '100%'
  },

  mutations: {
    updateAdapterResolution(state, { screenResolution, deviceRotate }) {
      state.resolution = Number(screenResolution)
      state.orientation = Number(deviceRotate)
      if (state.resolution === 1 && state.orientation === 1) {
        state.adapterResolution = 'pdef'
        state.anotherResolution = 'ldef'
      } else if (state.resolution === 1 && state.orientation === 0) {
        state.adapterResolution = 'ldef'
        state.anotherResolution = 'pdef'
      }
    },

    // 更新设备展示场景的宽高
    updateSceneSize(state, { width, height }) {
      state.sceneWidth = width
      state.sceneHeight = height
    },

    updateWorldScale(state, { x, y }) {
      state.worldScale.x = x
      state.worldScale.y = y
    }
  },

  actions: {
    updateOrientation(
      { state, commit, dispatch },
      {
        value,
        record = true,
        changeOrientationForCaptureSceneImage = false
      } = {}
    ) {
      if (value === state.orientation) return

      executeAction({
        action: getDeviceAction({
          newValue: {
            orientation: value,
            changeOrientationForCaptureSceneImage
          },
          oldValue: {
            orientation: state.orientation,
            changeOrientationForCaptureSceneImage
          }
        }),
        record
      })
    },

    updateSceneSizeByDeviceSize({ state, commit }, override) {
      const sceneContainer = document.querySelector('#scene-editor-container')
      const deviceContainer = document.querySelector('#active-scene-container')
      let actualWidth =
        deviceContainer.offsetWidth * state.scale > sceneContainer.offsetWidth
          ? deviceContainer.offsetWidth * state.scale
          : '100%'
      let actualHeight =
        deviceContainer.offsetHeight * state.scale > sceneContainer.offsetHeight
          ? deviceContainer.offsetHeight * state.scale
          : '100%'
      if (override) {
        actualWidth = deviceContainer.offsetWidth * state.scale
        actualHeight = deviceContainer.offsetHeight * state.scale
      }
      commit('updateSceneSize', {
        width: actualWidth,
        height: actualHeight
      })
    },

    updateScale({ state, commit, dispatch }, value) {
      state.scale = Number(value.toFixed(2))
    },

    adapterScale({ state, dispatch }) {
      const editorContainer = document.querySelector('#scene-editor-container')
      const reservedSpace = 120
      const maxWidth = editorContainer.offsetWidth - reservedSpace
      const maxHeight = editorContainer.offsetHeight - reservedSpace
      let maxScale = Math.min(maxWidth / state.width, maxHeight / state.height)
      if (maxScale > 2) {
        maxScale = 2
      }
      if (maxScale < 0.5) {
        maxScale = 0.5
      }
      dispatch('updateScale', maxScale)
    }
  }
}

export default device
